<button data-header (click)="toggleExpanded()">
  <div data-visual-wrapper>
    <span bspk-txt="labels-base">{{ label() }}</span>
    @if (subtext()) {
      <span bspk-txt="body-x-small" color="on-surface-variant-01">{{ subtext() }}</span>
    }
  </div>

  @if (badgeCount()) {
    <bspk-badge [count]="badgeCount()" />
  }

  <bspk-icon [name]="expanded() ? 'KeyboardArrowUp' : 'KeyboardArrowDown'"/>
</button>

<div data-content [@listAnimation]="expanded() ? 'expanded' : 'collapsed'">
  <ng-content />
</div>

@if (!hideDivider()) {
  <span data-bottom-line role="separator"></span>
}
